export default __webpack_public_path__ + "static/media/sync.a82833d5.svg";